// extracted by mini-css-extract-plugin
export default {"RemoveButton":"RemoveButton_RemoveButton__EMHgL"};